module.exports = __webpack_public_path__ + "img/公众号.3ab8c319.png";